import { Spacer } from "components/general/Spacer/Spacer";
import Decimal from "decimal.js";
import { Amount } from "types/amount";
import { Text } from "components/general/Text";
import { GlobalStore } from "store/global/GlobalStore";
import { useTokenListByChain } from "hooks/useTokenListByChain";
import { SerializedStyles } from "@emotion/react";
import { Hash } from "viem";

interface AmountAndUsdPriceProps {
  tokenAddress: Hash;
  amount: Amount;
  usdValue: Decimal;
  isAmountShown: boolean;
  isUsdValueShown?: boolean;
  css?: SerializedStyles;
}

export const AmountAndUsdPrice = ({
  tokenAddress,
  amount,
  usdValue,
  isAmountShown,
  isUsdValueShown = true,
  css,
}: AmountAndUsdPriceProps) => {
  const theme = GlobalStore.useState(s => s.theme);
  const tokenList = useTokenListByChain();
  if (!isAmountShown && !isUsdValueShown) {
    return null;
  }
  return (
    <div style={{ display: "flex", position: "relative" }}>
      {amount.value.gt(0) && usdValue.gt(0) && (
        <>
          {isAmountShown && (
            <>
              <Text textStyle="Paragraph" size="Large" css={css} color={theme.font.primary.default}>
                {amount.toDisplay(tokenAddress, tokenList)}
              </Text>
              <Spacer width={8} minWidth={8} />
            </>
          )}
          {isUsdValueShown && (
            <Text textStyle="Paragraph" size="Large" css={css}>
              $
              {Intl.NumberFormat(navigator.language, {
                maximumFractionDigits: 2,
                minimumFractionDigits: 2,
              }).format(usdValue.toNumber())}
            </Text>
          )}
        </>
      )}
    </div>
  );
};
